var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3332 21.5833C23.3332 23.8385 19.1545 24.5 13.9998 24.5C8.84518 24.5 4.6665 23.8385 4.6665 21.5833C4.6665 19.3282 8.84518 16.3333 13.9998 16.3333C19.1545 16.3333 23.3332 19.3282 23.3332 21.5833Z",
    stroke: "#C0BAC1",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 8.16667C18.6665 10.744 16.5772 12.8333 13.9998 12.8333C11.4225 12.8333 9.33317 10.744 9.33317 8.16667C9.33317 5.58934 11.4225 3.5 13.9998 3.5C16.5772 3.5 18.6665 5.58934 18.6665 8.16667Z",
    stroke: "#C0BAC1",
    strokeWidth: 1.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlank);
export default __webpack_public_path__ + "static/media/user-blank.8059fa2402b719a8c24813ce95f5ed6b.svg";
export { ForwardRef as ReactComponent };